import type { RefObject } from 'react';
import { isNotNil, isRecord } from '@wistia/type-guards';

// type guard that asserts that a given object is a valid React ref
export const isValidRef = (value: unknown): value is RefObject<null> => {
  return isNotNil(value) && isRecord(value) && 'current' in value;
};
